(() => {
  const selector = '.product__description :is(h1, h2, h3, h4, h5, h6)';
  const cleanHeadings = (root) => {
    const headings = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) headings.unshift(root);
    for (const heading of headings) {
      // Keep authored text, embedded media, IDs, styles and application placeholders.
      // Only a bare, empty rich-text heading is an unused navigation stop.
      if (heading.attributes.length || heading.children.length || heading.textContent.trim()) continue;
      heading.remove();
    }
  };
  cleanHeadings(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) cleanHeadings(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
